import { faCog } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useTranslation } from "react-i18next";
import { Label } from "semantic-ui-react";

import { PinTypeIcon } from "components";
import "modules/AppointmentDetails/components/Interventions/components/PinOverview/components/ImportantNotes/ImportantNotes.scss";

import type { Pin } from "models";

type Props = {
  pinLog?: Pin[];
};

export const ImportantNotes = ({ pinLog }: Props) => {
  if (!pinLog || !pinLog.length || !pinLog.some(pin => pin.visible_important_items)) return null;
  const visiblePinLogs = pinLog.filter(pin => pin.visible_important_items);
  const { t } = useTranslation();

  return (
    <div className="ImportantNotes">
      <div className="title" style={{ margin: "10px 0px" }}>
        {t("v8_important_notes", "Important notes")}
      </div>

      {visiblePinLogs.map(item => (
        <div key={item.id} className="icon-text-container">
          <Label>
            <PinTypeIcon pinTypeId={item.pin_type_id} key={item.pin_type_id} isPrint />
          </Label>
          {item.keep_parts ? (
            <>
              <Label basic className="label-container">
                <FontAwesomeIcon icon={faCog} color="#21BA45" />
                {t("v8_keep_parts", "Keep Parts")}
              </Label>
              <span>{item.note}</span>
            </>
          ) : (
            <span>{item.note}</span>
          )}
        </div>
      ))}
    </div>
  );
};
